import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Field, NumInput } from "@/components/join/Field";
import { PhotoPicker } from "@/components/join/PhotoPicker";
import { Success } from "@/components/join/Success";

const EMPTY = { name: "", power: "", participation: "", attacks: "", contact: "", notes: "" };

export const EnlistForm = ({ open }) => {
  const [f, setF] = useState(EMPTY);
  const [images, setImages] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: typeof v === "string" ? v : v.target.value }));

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await api.post("/public/enlist", { ...f, images }); setDone(true); setF(EMPTY); setImages([]); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  if (done) return <Success testid="enlist-success" title="Application sent" text="The leaders will see you in Recruit Watch. Keep an eye on Discord or in-game mail." onAgain={() => setDone(false)} />;
  return (
    <form onSubmit={submit} data-testid="enlist-form">
      {!open && <p className="lg-err" style={{ marginBottom: 16 }} data-testid="enlist-closed-note">Recruiting is paused during the event, but you can still apply. We'll review after it ends.</p>}
      <div className="lg-grid" style={{ marginBottom: 16 }}>
        <Field label="In-game name *"><input className="lg-input" value={f.name} onChange={set("name")} maxLength={60} required data-testid="enlist-name" /></Field>
        <Field label="Power"><NumInput value={f.power} onChange={set("power")} placeholder="1,250,000" testid="enlist-power" /></Field>
        <Field label="Atlantis participation"><NumInput value={f.participation} onChange={set("participation")} testid="enlist-participation" /></Field>
        <Field label="Attacks"><NumInput value={f.attacks} onChange={set("attacks")} testid="enlist-attacks" /></Field>
      </div>
      <div style={{ display: "grid", gap: 16, marginBottom: 18 }}>
        <Field label="Discord or contact" hint="So a leader can reach you."><input className="lg-input" value={f.contact} onChange={set("contact")} maxLength={80} data-testid="enlist-contact" /></Field>
        <Field label="Anything else?"><textarea className="lg-textarea" value={f.notes} onChange={set("notes")} maxLength={400} data-testid="enlist-notes" /></Field>
        <Field label="Screenshots (optional)" hint="Profile or Atlantis ranking, up to 4."><PhotoPicker value={images} onChange={setImages} testid="enlist-photos" /></Field>
      </div>
      {error && <p className="lg-err" style={{ marginBottom: 14 }} data-testid="enlist-error">{error}</p>}
      <button className="lg-btn" disabled={busy || !f.name.trim()} data-testid="enlist-submit">{busy ? "Sending…" : "Send application"}</button>
    </form>
  );
};
